import React, { useEffect, useState } from "react";
import Wrapper from "../helpers/Wrapper";
import SectionHead from "../components/SectionHead";
import CartItem from "../components/Cart/CartItem";
import { useCart } from "../hooks/useCart";
import FormatCurrency from "../helpers/FormatCurrency";
import LinkButton from "../ui/LinkButton";
import CartItemRow from "../components/Cart/CartItemRow";
import { Link } from "react-router-dom";
import AnimatePage from "../components/AnimatePage";
import { ChangePageTitle } from "../helpers/ChangeTitle";

function Cart() {
  ChangePageTitle("Cart");
  const [cart, setCart] = useState(null);

  const { data, isLoading } = useCart();
  useEffect(() => {
    setCart(data || null);
  }, [data]);

  if (isLoading) {
    <div>Loading...</div>;
  }

  return (
    <AnimatePage>
      <div className="w-full relative mx-auto max-w-[1350px] mt-9">
        <Wrapper>
          <SectionHead
            title={cart?.items?.length ? "Your Cart" : "Your cart is empty"}
            description={`Review your selected items before checkout. Ready to complete 
                        your purchase?`}
          />

          {/* Main */}

          {cart?.items?.length ? (
            <div className="w-full relative flex flex-col mt-16 lg:flex-row gap-10 lg:gap-7">
              {/* Cart-items */}
              <div className="w-full lg:w-9/12">
                {/* for small Screen */}
                <div className="w-full flex flex-col md:hidden space-y-4">
                  {cart?.items?.map((item, i) => (
                    <div key={i}>
                      <CartItem item={item} />
                    </div>
                  ))}
                </div>

                {/* For Large Screens */}

                <div className="w-full relative md:block hidden">
                  <table className="table border w-full">
                    <thead>
                      <tr>
                        <th className="px-4 py-3 border font-medium">
                          Product
                        </th>
                        <th className="px-4 py-3 border font-medium">
                          Quantity
                        </th>
                        <th className="px-4 py-3 border font-medium">Total</th>
                        <th className="px-4 py-3 border font-medium"></th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {cart?.items?.map((item, i) => (
                        <CartItemRow i={i} item={item} />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* =============================================  Cart other Into====================================== */}
              <div className="w-full lg:w-3/12 rounded-lg bg-containerBg px-5 pt-5 pb-14 h-full">
                {/* Footer */}
                <div className="w-full py-4 sticky bottom-0">
                  <div className="flex items-center justify-between">
                    <h1 className="font-medium text-lg">Subtotal</h1>
                    <h1 className="font-medium text-lg">
                      <FormatCurrency amount={cart?.grand_total} />
                    </h1>
                  </div>
                  <p className="text-sm mt-1 text-gray-500">
                    Taxes and shipping calculated at checkout
                  </p>
                  <Link
                    to={"/checkout"}
                    className="w-full mt-5 inline-block text-center border-black rounded-full py-4 
                             uppercase text-xs text-white font-medium border bg-slate-900 transition delay-75 ease-in-out"
                  >
                    Check out
                  </Link>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-center mt-7 items-center">
              <LinkButton to="/shop">CONTINUE SHOPPING</LinkButton>
            </div>
          )}
        </Wrapper>
      </div>
    </AnimatePage>
  );
}

export default Cart;
